var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopic = function SvgTopic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.833 4H8.5L7.167 2.667h-4c-.734 0-1.327.6-1.327 1.333l-.007 8c0 .733.6 1.333 1.334 1.333h11.18c.453 0 .82-.373.82-.82v-7.18c0-.733-.6-1.333-1.334-1.333m0 8H3.167V4h3.446l1.334 1.333h5.886zM12.5 8h-8V6.667h8zm-2.667 2.666H4.5V9.333h5.333z"
  })));
};
export default SvgTopic;